var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import api from 'src/Utils/api';
export var editBlockedDate = function (_a) {
    var id = _a.id, date = _a.date, general_block = _a.general_block, recurring = _a.recurring, entity_id = _a.entity_id, entity_type = _a.entity_type;
    var body = {
        booking_blocked_date: __assign(__assign(__assign(__assign(__assign({}, (date && { date: date })), (general_block !== undefined && { general_block: general_block })), (recurring !== undefined && { recurring: recurring })), (entity_id && { entity_id: entity_id })), (entity_type && { entity_type: entity_type })),
    };
    return api.put("/booking_blocked_dates/" + id, body);
};
